/**
 * Kundenname zur Meldung (Hans 14.10.2026): Organisation = Kunde
 * (RheinmetallNC, Lehner, …). Der Weg geht über die Anwendung der Meldung
 * (organisationSlug) zur Organisation (name). Beide Listen sind ohnehin
 * geladen (Anwendungen für die App-Namen, Organisationen für den Umschalter).
 */
import { useQuery } from "@tanstack/react-query"
import { api } from "@/services/api"
import { useOrganisationStore } from "@/store/organisation"

export function useKunden() {
  const { data: anwendungen } = useQuery({
    queryKey: ["applications"],
    queryFn: api.applications.list,
  })
  const { data: organisationen } = useQuery({
    queryKey: ["organisationen"],
    queryFn: api.organisationen.list,
    staleTime: 5 * 60 * 1000,
  })
  const gewaehlt = useOrganisationStore((s) => s.gewaehlt)
  const nameVonSlug = new Map((organisationen ?? []).map((o) => [o.slug, o.name]))
  const slugVonApp = new Map((anwendungen ?? []).map((a) => [a.id, a.organisationSlug]))

  /** Kundenname zur Anwendung einer Meldung — null, solange nichts geladen ist */
  const kundeVonAnwendung = (applicationId: number): string | null => {
    const slug = slugVonApp.get(applicationId)
    return (slug && nameVonSlug.get(slug)) || null
  }
  /** Kunde der aktuellen Sicht: gewählte Organisation, sonst die einzige — sonst null */
  const kundeDerSicht: string | null = gewaehlt
    ? nameVonSlug.get(gewaehlt) ?? null
    : organisationen?.length === 1
      ? organisationen[0].name
      : null
  /** Mehrere Kunden sichtbar → Kundenname gehört auf jede Karte */
  const mehrereKunden = !gewaehlt && (organisationen?.length ?? 0) > 1
  return { kundeVonAnwendung, kundeDerSicht, mehrereKunden }
}
